import ModalConfirmComponent from 'components/modal-confirm'
import SwitchComponent from 'components/switch'
import { useState } from 'react'
import { getTimeString } from 'utils/constants'
import './index.css'

const CalendarDefaultComponent: React.FC<{
  communityTime: number
  defaultTime?: number | null
  onSave: (toggleValue: number | null) => Promise<void>
}> = ({ communityTime, defaultTime, onSave }) => {
  const [isShow, setIsShow] = useState(false)

  const handleSubmit = async () => {
    await onSave(defaultTime === -1 ? null : -1)
    setIsShow(false)
  }
  return (
    <div className='w-full' data-testid='set-default-time-component'>
      <div className='flex items-center gap-2'>
        <SwitchComponent size='small' isChecked={defaultTime !== -1} onChange={() => setIsShow(true)} />
        <div className='text-sm text-gray-600 pt-1'>
          Driving daily at bell time (<span style={{ color: 'green' }}>{getTimeString(communityTime)}</span>).
          <br />
          Tap dates on calendar to customize.
        </div>
      </div>
      <ModalConfirmComponent
        isShow={isShow}
        title={defaultTime === -1 ? 'Enable bell time carpools?' : 'Disable bell time carpools?'}
        body={
          defaultTime === -1
            ? 'Enables carpool for all dates that are not customized.'
            : 'Clears carpool for all dates that are not customized.'
        }
        actionIcon={defaultTime === -1 ? 'yellowPowerIcon' : 'redBlockIcon'}
        actionText={defaultTime === -1 ? 'Turn On' : 'Turn Off'}
        onActionCancel={() => setIsShow(false)}
        onActionSubmit={handleSubmit}
      />
    </div>
  )
}

export default CalendarDefaultComponent
